<template>
  <v-navigation-drawer
    v-model="$store.state.menuAberto"
    v-resize="onResize"
    class="gradiente-menu-lateral"
    fixed
    width="304"
    dark
    data-cy="menu_lateral"
    :permanent="menuLateralFixo"
    :expand-on-hover="isDesktop"
  >
    <v-list-item
      two-line
      class="mt-5"
    >
      <v-list-item-avatar
        height="49"
        width="49"
        class="ml-0 mr-2 mb-5"
        :class="isDesktop ? 'ml-md-n2' : ''"
      >
        <v-img
          src="~@/assets/img/img-perfil.png"
          height="49"
          width="49"
        />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="title">
          Olá {{ primeiroNomeUsuario }}!
        </v-list-item-title>
        <v-list-item-subtitle>
          <a
            class="white--text"
            data-cy="button_logout"
            style="text-decoration: none"
            @click="deslogar()"
          >
            Sair
          </a>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="gradiente-divider" />

    <v-list>
      <v-list-item
        v-for="menu in menuLateral"
        :key="menu.label"
        link
        :to="menu.url"
        :data-cy="'menu' + menu.url"
        @click="closeMenu"
      >
        <v-list-item-icon>
          <v-icon>{{ menu.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ menu.label }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list
      v-if="!afiliadoProdutor.is_affiliate"
      class="link-fixo pt-0 pb-8"
    >
      <v-list-item
        link
        data-cy="btn_tornar_afiliado"
        @click="linkAfiliado()"
      >
        <v-list-item-icon>
          <v-img
            src="~@/assets/img/logo-marca.png"
            contain
            height="21"
            width="21"
          />
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title
            class="text-wrap"
          >
            <v-progress-linear
              v-show="afiliadoLoad"
              indeterminate
              color="white"
            />
            <span v-show="!afiliadoLoad">
              {{ afiliadoProdutor.label }}
            </span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-dialog
      v-if="!afiliadoProdutor.is_affiliate"
      v-model="afiliadoDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h6">
          Erro
        </v-card-title>
        <v-card-text>
          Tente novamente mais tarde.
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            @click="afiliadoDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>
<script>

import ApiMeuPerfil from '@/api/meuPerfil';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'MenuLateral',

  data: () => ({
    menuLateralFixo: false,
    menuLateral: [],
    afiliadoDialog: false,
    afiliadoLoad: false,
    afiliadoProdutor: {
      is_affiliate: true,
      url: null,
      label: null,
      target: null,
    },
  }),

  computed: {
    ...mapState({
      cacheMenu: 'menuLateral',
      cacheAfiliadoProdutor: 'afiliadoProdutor',
    }),
    ...mapGetters(['primeiroNomeUsuario']),

    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },

  created() {
    this.verificarStore();
  },

  methods: {
    ...mapActions(['setMenuLateral', 'setAfiliadoProdutor']),

    onResize() {
      this.menuLateralFixo = window.innerWidth > 959;
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.$store.dispatch('setMenuAberto', this.menuLateralFixo);
      }
    },

    openLocation(url) {
      const windowReference = window.open();
      windowReference.location = url;
    },

    async linkAfiliado() {
      this.afiliadoLoad = true;
      await ApiMeuPerfil.userAffiliate()
        .then((response) => {
          this.afiliadoProdutor = response.data;
          this.openLocation(this.afiliadoProdutor.url);
        })
        .catch(() => {
          this.afiliadoDialog = true;
        })
        .finally(() => {
          this.afiliadoLoad = false;
        });
    },

    async carregarMenuAfiliados() {
      await ApiMeuPerfil.userAffiliate()
        .then((response) => {
          this.afiliadoProdutor = response.data;
          this.setAfiliadoProdutor(this.afiliadoProdutor);
        })
        .catch(() => {
          this.afiliadoProdutor = [];
        });
    },

    closeMenu() {
      this.$store.dispatch('setMenuAberto', false);
    },

    deslogar() {
      const stateVuex = this.$store.state;
      const resetValores = {};

      Object.keys(stateVuex).forEach((key) => {
        if (key !== 'publicPages') resetValores[key] = '';
      });

      Object.assign(this.$store.state, resetValores);
      this.$router.push({
        name: 'login',
        params: {
          reload: true,
        },
      });
    },

    verificarStore() {
      if (this.cacheMenu.length === 0) {
        this.carregarMenuLateral();
      } else {
        this.menuLateral = this.cacheMenu;
      }
      if (this.cacheAfiliadoProdutor) {
        this.afiliadoProdutor = this.cacheAfiliadoProdutor;
      } else {
        this.carregarMenuAfiliados();
      }
    },

    async carregarMenuLateral() {
      await ApiMeuPerfil.userMenu()
        .then((response) => {
          this.menuLateral = response.data;
        })
        .catch(() => {
          this.menuLateral = [];
        })
        .finally(() => {
          this.setMenuLateral(this.menuLateral);
        });
    },

  },
};
</script>

<style scoped lang="scss">
.link-fixo { width: 100%; }
@media (min-height: 400px) {
  .link-fixo {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
.gradiente-divider{
  background-color: rgba(0, 0, 0, 0.87);
}
.gradiente-menu-lateral{
  background: url('~@/assets/img/logo-monetizze-menu.svg') no-repeat center 236px,
  linear-gradient(to right, var(--v-primary-base), var(--v-primary-lighten3));
  top: 48px !important;
  height: calc(100% - 48px) !important;
  z-index: 10;
}
</style>
